import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { AlertaService } from "../../services/alerta.service";
import { catchError, exhaustMap, map, tap } from "rxjs/operators";
import { of } from "rxjs";
import { HolidaysService } from "../../services/holiday.service";
import { findHolidayGroupAct, loadHolidayGroupByIdAct, saveHolidayGroupAct, saveSuccessHolidayGroupAct, setViolationsHolidayGroupAct, showMsgErrorAct, updateHolidayGroupAct, updateSuccessHolidayGroupAct } from "./holidays.action";

@Injectable()
export class HolidayGroupEffects {

    private actions$ = inject(Actions);
    private router = inject(Router);
    private holidaysService = inject(HolidaysService);
    private alerta = inject(AlertaService);

    findHolidayGroupEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findHolidayGroupAct),
            exhaustMap(action => this.holidaysService.findHolidaysById(action.id)
                .pipe(
                    map(holidayGroup => loadHolidayGroupByIdAct({ holidayGroup })),
                    catchError(error => {
                        if(error.status == 500) {
                            this.alerta.error("Se ha precentado un error interno", {
                                detail: error.error.details ,
                                onAccept: () => {
                                  this.router.navigate(['/holidays']);
                                }}); // . stack -> mas detalle
                            return of();
                        }else {
                            //return of(showMsgErrorAct({ error }));
                            this.alerta.error("Se ha precentado un error interno: ", {detail: error.message});
                            return of();
                        }
                    })
                ))
        )
    );

    saveHolidayGroupEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(saveHolidayGroupAct),
            exhaustMap(action => this.holidaysService.createHolidayGroup(action.holidayGroupNew)
                .pipe(
                    map(holidayGroupNew => saveSuccessHolidayGroupAct({ holidayGroupNew })),
                    catchError(error => (error.status == 400) ? of(setViolationsHolidayGroupAct({ holidayGroupForm: action.holidayGroupNew, violations: this.violationsToObject(error.error.parameterViolations) })) : of(showMsgErrorAct({ error }))
                    
                    )
                )
            )
        )
    );
    saveSuccessHolidayGroupEffect$ = createEffect(() => this.actions$.pipe(
        ofType(saveSuccessHolidayGroupAct),
        tap(() => {
            this.router.navigate(['/holidays']);
            this.alerta.correct("Oferta creado con exito!");
        })
    ), { dispatch: false });

    updateHolidayGroupEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(updateHolidayGroupAct),
            exhaustMap(action => this.holidaysService.updateHolidayGroup(action.holidayGroupUpdated)
                .pipe(
                    map(holidayGroupUpdated => updateSuccessHolidayGroupAct({ holidayGroupUpdated })),
                    catchError(error => {
                        if(error.status == 400) {
                            return of(setViolationsHolidayGroupAct({ holidayGroupForm: action.holidayGroupUpdated, violations: this.violationsToObject(error.error.parameterViolations)})) ;
                        }else {
                            return of(showMsgErrorAct({ error }));
                        }
                    })
                )
            )
        )
    );

    updateSuccessHolidayGroupEffect$ = createEffect(() => this.actions$.pipe(
        ofType(updateSuccessHolidayGroupAct),
        tap(() => {
            this.router.navigate(['/holidays']);
            this.alerta.correct("Oferta editado con exito!");
        })
    ), {dispatch: false});

    violationsToObject(violationsList: []): any {
        return violationsList.reduce((obj: { [x: string]: any; }, item: { path: string; message: any; }) => {
            obj[item.path.slice(item.path.indexOf('.') + 1)] = item.message;
            return obj;
        }, {});
    };
}